import {PickChildModel} from "../../models/edit/PickChildModel";
import {Asset} from "../../entities/Asset";
import {PagingCtrl} from "../PagingCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";

export class PickChildCtrl extends PagingCtrl<Asset>{
  public static $inject = ['$scope','$location','$state','$stateParams','$uibModalInstance','PickChildModel','parentAsset','NotificationService'];
  pickChildModel:PickChildModel;
  constructor($scope:any,
              $location: ng.ILocationService,
              stateService:StateService,
              stateParamsService:StateParams,
              public modalInstance:angular.ui.bootstrap.IModalServiceInstance,
              pickChildModel:PickChildModel,
              public parentAsset:Asset,
              notificationService:NotificationService) {
    super($scope, $location, stateService, stateParamsService, pickChildModel, notificationService);
    this.pickChildModel = pickChildModel;
    this.pickChildModel.init(parentAsset);
    this.getPaged();
  }
  init():any{
    //this.pagingModel.init(this.parentAsset);
  }

  Ok(){
    if(this.pickChildModel.selectedAsset != null){
      this.modalInstance.close(this.pickChildModel.selectedAssets);
    }
  }
  Cancel(){
    this.modalInstance.dismiss('cancel');
  }
}
